import * as React from 'react'

function SvgSl(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path fill="#0072C6" d="M0 0h450v300H0z" />
			<path fill="#FFF" d="M0 0h450v200H0z" />
			<path fill="#1EB53A" d="M0 0h450v100H0z" />
		</svg>
	)
}

export default SvgSl
